import React, { useEffect, useRef, useState } from 'react'

// import { Link } from 'react-router-dom'
// import applebg from '../../../assets/img/custom/applebg.png'
import about from '../../../assets/img/custom/about.avif'
import { useTranslation} from 'react-i18next';

const DownloadBanner = () => {
    const { t, i18n } = useTranslation();
    return (
    
        <section className='container' id='footer-form'>
            
            <div className='row py-5'>
                <div className='col-lg-7 col-12 d-flex align-items-center' >
                <div className='px-lg-5 pb-5 pt-2'>
                    <small className='text-warning'>{t('whyaecmcsubheading')}</small>
                    <h3 className='font-weight-light mb-3'>{t('whyaecmc')}</h3>
                    <p className='mb-3'>{t('whyaecmcpara1')}</p>
                    <p className='mb-3'>{t('whyaecmcpara2')}</p>


                </div>
                </div>
               
                <div className='col-lg-5 col-12 px-5 '>
                    <img src={about} style={{maxWidth:'100%',height:'auto' }}/>
                    
                </div>
            </div>
        </section>
     

    )
}

export default DownloadBanner